import React from "react";
import { Box, Button } from "@mui/material";
import Checkbox from "../../../components/controls/Checkbox";
import { FormattedMessage } from "react-intl";
import messages from "./messages";

export default function MachineSectionStopCodesDialog(props) {
    const handleCheckboxChange = (event) => {
        const stopReasonCodeId = Number(event.target.id);
        const checked = event.target.value;

        if (checked) {
            props.onChange([...props.stopReasonCodeIds, stopReasonCodeId]);
        } else {
            props.onChange(props.stopReasonCodeIds.filter((id) => id !== stopReasonCodeId));
        }
    };

    return (
        <Box sx={{ p: 1, m: 1 }}>
            <Box sx={{ width: '100%' }}>
                <FormattedMessage {...messages.stopReasonCodesHelpText} />
                <Box
                    marginTop="12px"
                    sx={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        alignContent: 'flex-start',
                    }}>
                    {(props.availableStopReasonCodes ?? []).map((item) => {
                        const isEnabled = props.stopReasonCodeIds.includes(item.id);
                        return (
                            <Box key={item.id} sx={{ flex: "0 0 33.3333%;" }}>
                                <Checkbox
                                    id={item.id}
                                    name={item.code}
                                    label={item.name}
                                    value={isEnabled}
                                    onChange={handleCheckboxChange}
                                />
                            </Box>
                        );
                    })}
                </Box>
            </Box>
            <Box>
                <Button
                    variant="contained"
                    sx={{ marginTop: 2 }}
                    onClick={props.handleSave}
                >
                    <FormattedMessage {...messages.saveButton} />
                </Button>
            </Box>
        </Box>
    );
}
